import React ,{ useState , useEffect } from 'react';
import webapi from '../../../api/webapi';

const SurfParameterBox = (props) =>{
    
    // constructor(props) {
    //     super(props);
    //     state = { books: [] };
    //     state = { chapters: [] };
    //     state = { SelectedBookGroup: '' };
    //     state = { SelectedBook: '' };
    //     state = { SelectedChapter: '' };
    //     //state = { PicLoadingQueue : 0 };
    // }

    const [books,setBooks]=useState([]);
    const [chapters,setChapters]=useState([]);
    const [selectedBookGroup,setSelectedBookGroup]=useState(undefined);
    // const [selectedBook,setSelectedBook]=useState(undefined);
    const [selectedChapter,setSelectedChapter]=useState(undefined);
    const [bookGroups,setBookGroups]=useState(undefined);

    // componentDidMount() {
    //     setState({ SelectedBook: '' });
    //     setState({ SelectedChapter: '' });

    //     GetBookGroups();

    //     props.setLoadingShow(false)
    // };

    useEffect(()=>{
        props.setLoadingShow(true)
        GetBookGroups();
    },[])



    const GetBookGroups = async () =>{
        props.setLoadingShow(true);
        await webapi.get('surf/allbookgroups/'+ props.lang)
            .then(response => {
                setBookGroups(response.data);
                if (response && response.data && response.data!==undefined)
                {
                    setSelectedBookGroup(response.data[0].Code);
                    props.setSelectedBookGroup(response.data[0].Code);
                    GetBooks(response.data[0].Code)
                }
                else
                {
                    //setSelectedBook('')
                    props.setSelectedBook('');
                    setSelectedChapter('')
                    props.setSelectedChapter('');
                }
            })
    }

    const GetBooks = async bookGroupCode =>{
        props.setLoadingShow(true);
        await webapi.get('surf/bookgroupsbook/'+bookGroupCode+'/'+ props.lang)
            .then(response => {
                setBooks(response.data);
                if (response.data && response.data!==undefined && response.data.length>0)
                {
                    //console.log('SurfParameterBox2->books=',books)
                    //setSelectedBook(books[0].Code)
                    props.setSelectedBook(response.data[0].Code);
                    GetChapters(response.data[0].Code)
                }
                else
                {
                    //setSelectedBook('')
                    props.setSelectedBook('');
                    //setSelectedChapter('')
                    props.setSelectedChapter('');
                    props.setLoadingShow(false);
                }  
            })
            
        //         
    }

    const GetChapters = async BookCode =>{
        props.setLoadingShow(true)
        await webapi.get('surf/bookschapter/'+ BookCode+'/'+ props.lang)
            .then(response => {
                setChapters(response.data);
                if (response.data && response.data!==undefined && response.data.length>0)
                {
                    //setSelectedChapter(chapters[0].Code)
                    props.setSelectedChapter(response.data[0].Code);
                }                
            })
        props.setLoadingShow(false) 
    }

    const onChangeBookGroupSelect = async event => {
        props.setLoadingShow(true)
        setSelectedBookGroup(event.target.value);
        //console.log(event.target.value);
        props.setSelectedBookGroup(event.target.value);
        GetBooks(event.target.value);
    };

    const onChangeBookSelect = async event => {
        props.setLoadingShow(true)
        //setSelectedBook(event.target.value);
        props.setSelectedBook(event.target.value);
        GetChapters( event.target.value );
    };

    const onChangeChapterSelect = async event => {
        //setSelectedChapter(event.target.value)
        props.setSelectedChapter(event.target.value);
        props.setLoadingShow(false)
    };

    return (
        <div className="container-fluid" id="words_search_form" key='b1'>
            <div className="container">
                <br />
                <div className="select_param">           
                    <label>{props.pageData.length!==0 && props.pageData[0].F20101!== undefined? props.pageData[0].F20101:20101/*نوع متن*/}</label>
                    <select className="" id='select' onChange={onChangeBookGroupSelect} >
                        {   bookGroups != null 
                            ?
                            (   
                                bookGroups.map((bookGroup) =>{
                                    return  (
                                        <option key={bookGroup.Code} value={bookGroup.Code}>{bookGroup.Title}</option> 
                                    )
                                })
                            )
                            :
                            <option key="-1">-</option>       
                        }
                    </select>
                </div>
                <div className="select_param">           
                    { 
                        (selectedBookGroup==="2")
                        ?
                        <label>{props.pageData.length!==0 && props.pageData[0].F20106!== undefined?props.pageData[0].F20106:20106/*نوع کتیبه*/}</label>
                        :
                        <label>{props.pageData.length!==0 && props.pageData[0].F20102!== undefined?props.pageData[0].F20102:20102/*نام متن*/}</label>
                    }
                    <select onChange={onChangeBookSelect} className="">
                        {   books != null 
                            ?
                            (   
                                books.map((book) =>{
                                    return  (
                                        <option key={book.Code} value={book.Code}>{book.Title}</option> 
                                    )
                                })
                            )
                            :
                            <option key="-1">-</option>       
                        }
                    </select>
                </div>
                <div className="select_param" >           
                    { 
                        (selectedBookGroup==="2")
                        ?
                        <label>{props.pageData.length!==0 && props.pageData[0].F20107!== undefined?props.pageData[0].F20107:20107/*نام کتیبه*/}</label>
                        :
                        <label>{props.pageData.length!==0 && props.pageData[0].F20103!== undefined?props.pageData[0].F20103:20103/*شماره فصل*/}</label>
                    }
                    <select onChange={onChangeChapterSelect}  className="" >
                        {   chapters != null 
                            ?
                            (   chapters.map((chapter,i) =>{
                                    return  (
                                        (chapters.length>1 && i===0)
                                        ?
                                        (
                                            [
                                                <option key={'j'+i+chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                            ]
                                        )
                                        :
                                        (
                                            <option key={'k'+i+chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                        )
                                    )
                                })
                            )
                            :
                            <option key="b2">{props.pageData.length!==0 && props.pageData[0].F29902!== undefined?props.pageData[0].F29902:29902/*همه*/}</option>       
                        }
                    </select>
                </div>
            </div>
        </div>
    )
}

export default SurfParameterBox;